export default __webpack_public_path__ + "static/media/charity_logo.1bc8eeb7.png";